"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkbook = exports.exportFile = void 0;
var base_1 = require("./utils/base");
var columnsUtils_1 = require("./utils/columnsUtils");
var valueUtils_1 = require("./utils/valueUtils");
var cellStylesUtils_1 = require("./utils/cellStylesUtils");
var XLSX = require('@pengchen/xlsx');
/**
 * 导出
 * @param fileName
 * @param sheetNames
 * @param columns
 * @param dataSource
 * @param showHeader 是否显示表头
 * @param raw 是否格式化值的类型
 * @param cellStyle 单元格样式
 * @param headerCellStyle 单元格样式
 * @param bodyCellStyle 单元格样式
 * @param useRender 是否使用render返回的值
 * @param rowHpx
 * @param onTxBodyRow
 */
var exportFile = function (_a) {
    var _b = _a.fileName, fileName = _b === void 0 ? 'table.xlsx' : _b, _c = _a.sheetNames, sheetNames = _c === void 0 ? ['sheet1'] : _c, _d = _a.columns, columns = _d === void 0 ? [] : _d, _e = _a.dataSource, dataSource = _e === void 0 ? [] : _e, _f = _a.showHeader, showHeader = _f === void 0 ? true : _f, _g = _a.raw, raw = _g === void 0 ? false : _g, _h = _a.rowHpx, rowHpx = _h === void 0 ? 25 : _h, _j = _a.cellStyle, cellStyle = _j === void 0 ? {} : _j, _k = _a.headerCellStyle, headerCellStyle = _k === void 0 ? {} : _k, _l = _a.bodyCellStyle, bodyCellStyle = _l === void 0 ? {} : _l, _m = _a.useRender, useRender = _m === void 0 ? true : _m, onTxBodyRow = _a.onTxBodyRow;
    var wb = (0, exports.getWorkbook)({
        sheetNames: sheetNames,
        columns: columns,
        dataSource: dataSource,
        showHeader: showHeader,
        raw: raw,
        rowHpx: rowHpx,
        cellStyle: cellStyle,
        headerCellStyle: headerCellStyle,
        bodyCellStyle: bodyCellStyle,
        useRender: useRender,
        onTxBodyRow: onTxBodyRow,
    });
    XLSX.writeFile(wb, fileName);
    return wb;
};
exports.exportFile = exportFile;
/**
 * 获取wb对象
 */
var getWorkbook = function (_a) {
    var _b = _a.sheetNames, sheetNames = _b === void 0 ? ['sheet1'] : _b, _c = _a.columns, columns = _c === void 0 ? [] : _c, _d = _a.dataSource, dataSource = _d === void 0 ? [] : _d, _e = _a.showHeader, showHeader = _e === void 0 ? true : _e, _f = _a.raw, raw = _f === void 0 ? false : _f, _g = _a.rowHpx, rowHpx = _g === void 0 ? 25 : _g, _h = _a.cellStyle, cellStyle = _h === void 0 ? {} : _h, _j = _a.headerCellStyle, headerCellStyle = _j === void 0 ? {} : _j, _k = _a.bodyCellStyle, bodyCellStyle = _k === void 0 ? {} : _k, _l = _a.useRender, useRender = _l === void 0 ? true : _l, onTxBodyRow = _a.onTxBodyRow;
    var Sheets = {};
    sheetNames.forEach(function (sheetName, sheetIndex) {
        var _columns = (0, base_1.sameType)(columns[sheetIndex], 'Array') ? columns[sheetIndex] : columns;
        var _dataSource = (0, base_1.sameType)(dataSource[sheetIndex], 'Array') ? dataSource[sheetIndex] : dataSource;
        var sheet = formatToSheet({
            columns: _columns,
            dataSource: _dataSource,
            useRender: useRender,
            showHeader: showHeader,
            raw: raw,
            rowHpx: rowHpx,
            cellStyle: cellStyle,
            headerCellStyle: headerCellStyle,
            bodyCellStyle: bodyCellStyle,
            onTxBodyRow: onTxBodyRow,
        }).sheet;
        Sheets[sheetName] = sheet;
    });
    return {
        SheetNames: sheetNames,
        Sheets: Sheets,
    };
};
exports.getWorkbook = getWorkbook;
/**
 * 转换成sheet对象
 */
var formatToSheet = function (_a) {
    var columns = _a.columns, dataSource = _a.dataSource, showHeader = _a.showHeader, raw = _a.raw, rowHpx = _a.rowHpx, cellStyle = _a.cellStyle, headerCellStyle = _a.headerCellStyle, bodyCellStyle = _a.bodyCellStyle, useRender = _a.useRender, onTxBodyRow = _a.onTxBodyRow;
    var sheet = {};
    var $cols = [];
    var $rows = [];
    var $merges = [];
    //
    var _b = (0, columnsUtils_1.flattenColumns)({ columns: columns }), flatColumns = _b.columns, level = _b.level;
    var headerLevel = level;
    if (showHeader) {
        for (var i = 0; i < headerLevel; i++) {
            $rows.push({ hpx: rowHpx });
        }
        // 表头信息
        var headerData = getHeaderData({ columns: columns, headerLevel: headerLevel, cellStyle: cellStyle, headerCellStyle: headerCellStyle });
        Object.assign(sheet, headerData.sheet);
        $merges.push.apply($merges, headerData.merges);
    }
    else {
        headerLevel = 0;
    }
    //
    flatColumns.forEach(function (col, colIndex) {
        var key = col.dataIndex || col.key;
        $cols.push({ wpx: (0, columnsUtils_1.formatToWpx)(col.width || col.minWidth) });
        var xAxis = XLSX.utils.encode_col(colIndex);
        dataSource.forEach(function (data, rowIndex) {
            if (colIndex === 0) {
                $rows.push({ hpx: rowHpx });
            }
            var value = (0, valueUtils_1.getPathValue)(data, key);
            if (col.render) {
                var renderResult = col.render(value, data, rowIndex);
                value = useRender ? (0, valueUtils_1.getRenderValue)(renderResult) : value;
                var merge = getMerge({ renderResult: renderResult, colIndex: colIndex, rowIndex: rowIndex, headerLevel: headerLevel });
                if (merge) {
                    $merges.push(merge);
                }
            }
            if (col.xlsxRender) {
                value = col.xlsxRender(value, data, rowIndex);
            }
            var txBodyRowStyle = {};
            var txBodyCellStyle = {};
            if (onTxBodyRow) {
                var result = onTxBodyRow(data, rowIndex);
                txBodyRowStyle = (result === null || result === void 0 ? void 0 : result.style) || {};
            }
            if (col.onTxBodyCell) {
                var result = col.onTxBodyCell(data, rowIndex);
                txBodyCellStyle = (result === null || result === void 0 ? void 0 : result.style) || {};
            }
            sheet["".concat(xAxis).concat(headerLevel + rowIndex + 1)] = {
                t: ((raw && typeof value === 'number') || col.valueType === 'number') ? 'n' : 's',
                v: value !== null && value !== void 0 ? value : '',
                s: (0, cellStylesUtils_1.getStyles)(__assign(__assign(__assign(__assign({ alignmentHorizontal: 'left' }, cellStyle), bodyCellStyle), txBodyRowStyle), txBodyCellStyle)),
            };
        });
    });
    var xe = XLSX.utils.encode_col(Math.max(flatColumns.length - 1, 0));
    var ye = headerLevel + dataSource.length;
    sheet['!ref'] = "A1:".concat(xe).concat(ye);
    sheet['!cols'] = $cols;
    sheet['!rows'] = $rows;
    sheet['!merges'] = $merges;
    return {
        sheet: sheet
    };
};
/**
 * 获取表头数据
 */
var getHeaderData = function (_a) {
    var columns = _a.columns, headerLevel = _a.headerLevel, cellStyle = _a.cellStyle, headerCellStyle = _a.headerCellStyle;
    var sheet = {};
    var merges = [];
    var headerArr = (0, columnsUtils_1.getHeader2dArray)({ columns: columns, headerLevel: headerLevel });
    var mergesWeakMap = new WeakMap();
    headerArr.forEach(function (rowsArr, rowIndex) {
        rowsArr.forEach(function (cols, colIndex) {
            var xAxis = XLSX.utils.encode_col(colIndex);
            var style = (cols === null || cols === void 0 ? void 0 : cols.txHeaderCellStyle) || {};
            // https://github.com/SheetJS/sheetjs#cell-object
            sheet["".concat(xAxis).concat(rowIndex + 1)] = {
                t: 's',
                v: cols.title,
                s: (0, cellStylesUtils_1.getStyles)(__assign(__assign(__assign({ fillFgColorRgb: 'e9ebf0', fontBold: true }, cellStyle), headerCellStyle), style)),
            };
            if (cols.merges && !mergesWeakMap.get(cols.merges)) {
                mergesWeakMap.set(cols.merges, true); // Microsoft Excel 如果传了相同的merges信息，文件会损坏，做个去重
                merges.push(cols.merges);
            }
        });
    });
    return {
        sheet: sheet,
        merges: merges
    };
};
/**
 * 获取单个合并信息
 */
var getMerge = function (_a) {
    var renderResult = _a.renderResult, colIndex = _a.colIndex, rowIndex = _a.rowIndex, headerLevel = _a.headerLevel;
    if (renderResult === null || renderResult === void 0 ? void 0 : renderResult.props) {
        var _b = renderResult.props, colSpan = _b.colSpan, rowSpan = _b.rowSpan;
        if ((colSpan && colSpan !== 1) || (rowSpan && rowSpan !== 1)) {
            var realRowIndex = rowIndex + headerLevel;
            var merge = {
                s: { c: colIndex, r: realRowIndex },
                e: {
                    c: colIndex + (colSpan || 1) - 1,
                    r: realRowIndex + (rowSpan || 1) - 1
                },
            };
            return merge;
        }
    }
    return false;
};
